import axios from "axios";
import { axiosApi } from "../constants/Constant";
import {
    isAbortError, shouldRetryRequest, extractBlobErrorMessage,
    isTokenExpired, isAuthError, clearAuthAndRedirect
} from "./axiosErrorHelpers";

const axiosInstance = axios.create({});


axiosInstance.interceptors.request.use(
  async (request) => {
    let token = localStorage.getItem("token");
    request.headers.setAuthorization(
      `Bearer ${token}`
    );
    return request;
  },
  (error) => {
    throw (error.response.data) || axiosApi.ERROR;
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.status === 203) {  //NOSONAR
      
    }
    else {
      return response;
    }
  },

  async (error) => {
    if (axios.isCancel(error) || isAbortError(error)) {
      throw error;
    }
    
    console.log("error======", JSON.stringify(error));
    const originalRequest = error?.response?.config;
    
    if (shouldRetryRequest(error, originalRequest)) {
      console.log('Token expired, attempting to refresh...');
      const errorMessage = await extractBlobErrorMessage(error);

      if (isTokenExpired(errorMessage)) {
        originalRequest._retry = true;
        const refreshToken = localStorage.getItem("refreshToken");
        
        try {
          const response = await axiosInstance.post(
            `${process.env.REACT_APP_BASE_URL}/refreshtoken`,
            { "refreshToken": refreshToken }
          );
          localStorage.setItem("token", response.data.data.access_token);
          localStorage.setItem("refreshToken", response.data.data.refresh_token);
          const oldresponse = await axiosInstance.request(originalRequest);
          return oldresponse;
        } catch (refreshError) {
          console.error('Token refresh failed:', refreshError);
          clearAuthAndRedirect();
          throw (refreshError.response?.data) || axiosApi.ERROR;
        }
      }
    }
    
    if (isAuthError(error.response?.data?.message)) {
      clearAuthAndRedirect();
    }
    
    throw (error.response?.data) || axiosApi.ERROR;
  }
);


export default axiosInstance;
